import React from "react";
import { styled, keyframes, css } from "styled-components";
import { FocusOn } from "react-focus-on";
import Portal from "../Portal";
import { Close } from "../../icons";
import mediaQueries from "../../styles/mediaQueries";
const enterAnimation = keyframes `
  0%   {opacity: 0; }
  100% {opacity: 1;}
`;
const Backdrop = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.24);
  animation: ${enterAnimation} 300ms linear;
  animation-iteration-count: 1;
`;
const StyledModal = styled.div `
  position: fixed;
  z-index: 9999;
  margin: auto;
  border-radius: 4px;
  outline: none;
  background: #ffffff;
  box-shadow: 0 0.125rem 1.5rem 0 rgba(0, 0, 0, 0.25);
  max-width: 1120px;
  width: 100%;
  padding: 0;
  color: #222222;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: ${enterAnimation} 300ms linear;
  animation-iteration-count: 1;
  ${({ dialog }) => dialog &&
    css `
      max-width: 640px;
      text-align: center;
    `};
  ${mediaQueries.down("small") `
    ${({ dialog }) => !dialog &&
    css `
        top: 0;
        bottom: 0;
      `};
      left: 0;
      right: 0;

      min-width: 18.75rem;
      ${({ xl }) => xl &&
    css `
          border-radius: 0;
          max-height: 100vh;
        `};
  `};
  ${mediaQueries.up("small") `
    ${({ fullscreen }) => !fullscreen &&
    css `
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      `};
    ${({ xl }) => xl &&
    css `
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transform: translate(0, 0);
        max-width: 90vw;
      `};
  `}
  ${mediaQueries.up("giant") `
    ${({ xl }) => xl &&
    css `
        max-width: 90rem;
      `};
  `}
  ${({ fullscreen }) => fullscreen &&
    css `
      max-width: 100%;
      height: 100%;
      max-height: 100%;
      box-shadow: none;
      border: 0;
      border-radius: 0;
      top: 0;
      bottom: 0;
      transform: none;
      left: 0;
      right: 0;
    `};
 
`;
export const ModalContent = styled.div `
  width: 100%;
  padding: 0.5rem 1.25rem 2rem;
  ${mediaQueries.up("small") `
    padding: 1.5rem 4.5rem 7.5rem;
  `};
`;
const ModalGuts = styled.div `
  width: 100%;
  overflow: auto;
  ${ModalContent} {
    ${({ hasHeader }) => !hasHeader &&
    css `
        padding-top: 4rem;
        ${mediaQueries.down("small") `
            padding-top: 2rem;
          `};
      `};
  }
`;
const InternalModalContent = styled.div `
  position: relative;
`;
const CloseButton = styled.button `
  position: absolute;
  right: 1rem;
  top: 1rem;
  border: 0;
  background: transparent;
  align-self: flex-end;
  cursor: pointer;
  padding: 0;
  margin: 0;
  height: 2rem;
  width: 2rem;
  z-index: 9999991;
  ${mediaQueries.up("small") `
    right: 1.5rem;
    top: 1.5rem;
    ${({ dialog }) => dialog &&
    css `
        right: 1rem;
        top: 1rem;
      `};
  `};
  svg {
    fill: #000000;
    width: 1.2rem;
    height: 1.2rem;
  }
`;
const Header = styled.div `
  padding: 1.2rem 1.25rem 1rem;

  ${mediaQueries.up("small") `
    padding: 3rem 4.5rem 0rem;
  `};
`;
const Heading = styled.h1 `
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.875rem;
  margin-bottom: 0rem;
  ${mediaQueries.up("small") `
    font-size: 2rem;
    margin-bottom: 0.5rem;
  `};
`;
export const DialogContent = styled.div `
  width: 100%;
  padding: 0.5rem 1.5rem 2rem;
  ${mediaQueries.up("small") `
    padding: 0.5rem 4.5rem 2rem;
  `};
`;
export const ModalActions = styled.div `
  padding: 0.5rem 1.25rem 2.5rem;
  ${mediaQueries.up("small") `
    padding: 0.5rem 4.5rem 5rem;
  `};
`;
export const Modal = ({ xl = false, fullscreen = false, dialog = false, label, ingress, onRequestClose, hideHeader, children, }) => (React.createElement(Portal, null,
    React.createElement(Backdrop, null),
    React.createElement(FocusOn, { onEscapeKey: onRequestClose, onClickOutside: onRequestClose },
        React.createElement(StyledModal, { xl: xl, fullscreen: fullscreen, dialog: dialog, "aria-labelledby": label },
            React.createElement(ModalGuts, { hasHeader: !hideHeader },
                !hideHeader && (React.createElement(Header, null,
                    React.createElement(Heading, null, label),
                    ingress && ingress)),
                React.createElement(InternalModalContent, null, children)),
            React.createElement(CloseButton, { dialog: dialog, onClick: onRequestClose, "aria-label": "Lukk" },
                React.createElement(Close, null))))));
export default Modal;
//# sourceMappingURL=Modal.js.map